<template>
  <div class="card my-3">
    <div class="row no-gutters align-items-center position-relative">
      <img
        src="@/assets/SI201905060148_news-edit.jpg"
        srcset="@/assets/SI201905060148_news-edit.jpg 1x, @/assets/SI201905060148_news-edit@2x.jpg 2x"
        :alt="$t('audioStickerCard.header')"
        class="rounded-top w-100"
      >
      <section class="card-body">
        <!-- SELECTOR -->
        <div
          class="rounded-pill mb-4 surface-base w-100 d-flex"
        >
          <button
            class="btn w-50 text-center d-flex justify-content-center align-items-center"
            :class="{'btn-primary': toggle}"
            @click="setToggle(true)"
            v-text="'Recorded audio'"
          />
          <button
            class="btn w-50 text-center "
            :class="{'btn-primary': !toggle}"
            @click="setToggle(false)"
            v-text="'pre recorded stickers'"
          />
        </div>

        <AudioStickerRecorder
          v-show="toggle"
          :participant="participant"
        />

        <AudioStickerForm
          v-show="!toggle"
          :participant="participant"
        />
      </section>
    </div>
  </div>
</template>

<script>
import AudioStickerRecorder from '@/components/AudioStickerRecorder.vue'
import AudioStickerForm from '@/components/AudioStickerForm.vue'

export default {
  name: 'AudioStickerParticipantCard',
  components: {
    AudioStickerForm,
    AudioStickerRecorder
  },
  props: {
    participant: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      toggle: true
    }
  },
  methods: {
    setToggle(bool) {
      this.toggle = bool
    }
  }
}
</script>

<style lang="scss">
.surface-base {
  background-color: $surface-base
}
</style>
